import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router }                       from '@angular/router';
import { Subscription }                 from 'rxjs/Subscription';

import * as providers from '../providers/providers';
import * as models    from '../models/models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  loggin: boolean = true;
  logged: models.FirebaseUser = null;
  _logged_subscription: Subscription;


  constructor(private router: Router, private db: providers.StamplingDB) {}

  ngOnInit() {
    this._logged_subscription = this.db.subscribeLogin().subscribe((user) => this.loadUser(user))
    this.db.load();
  }

  ngOnDestroy() {
    this._logged_subscription.unsubscribe();
  }

  loadUser(user) {
    console.log("load user"+user);
    this.loggin=false;
    if (user) {
      this.logged = user;
      this.router.navigate(["/dashboard"])
    } else {
      this.logged = null;
    }
  }

  logout() {
    this.logged = null;
    this.db.logout();
  }

}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/app/app.component.ts